const dedupMap = {}

export default function dedup(action, payload, fn) {
  return new Promise(function(resolve, reject) {
    const key = action + '-' + JSON.stringify(payload)
    let payloadData = dedupMap[key]
    if (!payloadData) {
      payloadData = dedupMap[key] = { resolvers: [resolve], rejecters: [reject] }
      fn()
        .then(value => {
          if (dedupMap[key]) {
            dedupMap[key].resolvers.forEach(resolve => resolve(value))
            delete dedupMap[key]
          }
        })
        .catch(e => {
          if (dedupMap[key]) {
            dedupMap[key].rejecters.forEach(reject => reject(e))
            delete dedupMap[key]
          }
        })
    } else {
      payloadData.resolvers.push(resolve)
      payloadData.rejecters.push(reject)
    }
  })
}
